export const testimonialsData = [
  {
    id: 1,
    name: 'Mehmet Yılmaz',
    rating: 5,
    comment: 'Laptop tamiri için gittim, aynı gün teslim aldım. Hem hızlı hem de çok uygun fiyatlı. Kesinlikle tavsiye ederim. Bilgisayar tamiri konusunda gerçekten profesyoneller.',
    date: '15 Ocak 2024',
    avatar: 'MY',
  },
  {
    id: 2,
    name: 'Ayşe Demir',
    rating: 5,
    comment: '2. el bilgisayar almak için araştırırken ES Bilgisayar\'ı buldum. Ürünler gerçekten sıfır ayarında, fiyatlar çok makul. İkinci el laptop alımında güvenle tercih edebilirsiniz.',
    date: '12 Ocak 2024',
    avatar: 'AD',
  },
  {
    id: 3,
    name: 'Can Öztürk',
    rating: 5,
    comment: 'Masaüstü bilgisayar tamiri için geldim. Ekran kartı arızasını çok hızlı tespit ettiler ve uygun fiyata çözdüler. Teknik servis kalitesi mükemmel, herkese tavsiye ederim.',
    date: '10 Ocak 2024',
    avatar: 'CÖ',
  },
  {
    id: 4,
    name: 'Zeynep Kaya',
    rating: 5,
    comment: 'Eski bilgisayarımı satmak için gittim, çok adil bir fiyat verdiler. Aynı gün nakit ödeme yaptılar. 2. el bilgisayar alım satım konusunda çok güvenilirler.',
    date: '8 Ocak 2024',
    avatar: 'ZK',
  },
  {
    id: 5,
    name: 'Burak Şahin',
    rating: 5,
    comment: 'Oyuncu bilgisayarı tamiri için başvurdum. Soğutma sistemini temizlediler ve termal macun değişimi yaptılar. Bilgisayarım yeni gibi çalışıyor. Profesyonel bir ekip.',
    date: '5 Ocak 2024',
    avatar: 'BŞ',
  },
  {
    id: 6,
    name: 'Elif Arslan',
    rating: 5,
    comment: 'Notebook tamiri ve format atma hizmeti aldım. Çok hızlı ve özenli çalıştılar. Bilgisayar bakım konusunda gerçekten uzmanlar. Fiyat performans açısından harika.',
    date: '3 Ocak 2024',
    avatar: 'EA',
  },
];